import { render, staticRenderFns } from "./GiftCardManagerList.vue?vue&type=template&id=014945d4&scoped=true&"
import script from "./GiftCardManagerList.vue?vue&type=script&lang=js&"
export * from "./GiftCardManagerList.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardManagerList.vue?vue&type=style&index=0&id=014945d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014945d4",
  null
  
)

export default component.exports